"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    standardPerformance: {
        title: 'Standard Performance',
        highlyProficient: 'Highly Proficient',
        proficient: 'Proficient',
        partiallyProficient: 'Partially Proficient',
        notYetProficient: 'Not Yet Proficient',
        link: 'See all',
        chartAriaLabel: 'vertical grouped bar of standard performace, comparing {{count}} standards.',
        standard: 'Standard',
        quantity: 'Quantity of questions by standards',
        seeAllAriaLabel: 'See all standards performance report',
    },
};
